module.exports = __webpack_public_path__ + "static/FlowerCakeMiniCart-26ca4b014a79af41d6a8ad25c042ac2c.png";